import { useEffect } from 'react'

import { useTracker } from '../../TrackerProvider.js'

import { TargetAnalyticsContext } from './snowplow.js'

interface UseAnalyticsProps {
  target?: Partial<TargetAnalyticsContext>
}

export const useAnalytics = ({ target }: UseAnalyticsProps = {}) => {
  const { tracker, unsetTracker } = useTracker()

  useEffect(() => {
    if (!tracker) {
      return null
    }

    tracker.setTarget(target)

    return () => {
      unsetTracker(target)
    }
  }, [tracker, target, unsetTracker])

  return tracker
}
